import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../public/images/new/heselcare.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-7ee5bb3a")

_pushScopeId("data-v-7ee5bb3a")
const _hoisted_1 = { class: "hesel-care__header header" }
const _hoisted_2 = { class: "header__title" }
const _hoisted_3 = /*#__PURE__*/_createVNode("img", {
  class: "link--image",
  src: _imports_0,
  alt: "HESEL CARE"
}, null, -1)
const _hoisted_4 = { class: "mobile-button" }
const _hoisted_5 = /*#__PURE__*/_createVNode("span", { class: "line" }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("span", { class: "line" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("span", { class: "line" }, null, -1)
const _hoisted_8 = { class: "header__navs" }
const _hoisted_9 = {
  class: "simple__header header",
  style: {"display":"none"}
}
const _hoisted_10 = { class: "header__title" }
const _hoisted_11 = /*#__PURE__*/_createVNode("img", {
  class: "link--image",
  src: _imports_0,
  alt: "HESEL CARE"
}, null, -1)
const _hoisted_12 = /*#__PURE__*/_createVNode("i", {
  class: "pi pi-arrow-circle-left",
  style: {"font-size":"2rem"}
}, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_router_link = _resolveComponent("router-link")
  const _component_MainNavigation = _resolveComponent("MainNavigation")
  const _component_AuthNavigation = _resolveComponent("AuthNavigation")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("header", _hoisted_1, [
      _createVNode("div", null, [
        _createVNode("h1", _hoisted_2, [
          _createVNode(_component_router_link, {
            to: { name: _ctx.RouterName.HOME },
            class: "link"
          }, {
            default: _withId(() => [
              _hoisted_3
            ]),
            _: 1
          }, 8, ["to"])
        ]),
        _createVNode("div", {
          class: ["header__navs__back", _ctx.hamburger ? '-active' : '']
        }, [
          _createVNode("div", {
            class: ["header__navs__wrapped", _ctx.hamburger ? 'hamburger -active' : 'hamburger']
          }, [
            _createVNode("div", _hoisted_4, [
              _createVNode("div", {
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleHamburger && _ctx.toggleHamburger(...args)))
              }, [
                _hoisted_5,
                _hoisted_6,
                _hoisted_7
              ])
            ]),
            _createVNode("div", _hoisted_8, [
              _createVNode(_component_MainNavigation, {
                class: ["service-nav", 
                _ctx.hamburger ? 'nav-container -active' : 'nav-container -close'
              ]
              }, null, 8, ["class"]),
              _createVNode(_component_AuthNavigation, {
                class: ["auth-nav", 
                _ctx.hamburger ? 'nav-container -active' : 'nav-container -close'
              ]
              }, null, 8, ["class"])
            ])
          ], 2),
          _createVNode("div", {
            class: "out",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.toggleHamburger && _ctx.toggleHamburger(...args)))
          })
        ], 2)
      ])
    ]),
    _createVNode("header", _hoisted_9, [
      _createVNode("h1", _hoisted_10, [
        _createVNode(_component_router_link, {
          to: { name: _ctx.RouterName.HOME, query: { redirect: '/' } },
          class: "link"
        }, {
          default: _withId(() => [
            _hoisted_11
          ]),
          _: 1
        }, 8, ["to"])
      ]),
      _createVNode("div", {
        class: "back-button",
        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
      }, [
        _hoisted_12
      ])
    ])
  ], 64))
})